import {legacyStaffingDelivery} from '../../phases/phaseApi';
import { useMemo } from 'react';
import { supabase } from '../../supabaseClient';
import {
  createJobOperationsController,
  JobOperationsRepository,
  JobOperationsWebhooks,
} from '../../components/job-workspace/jobOperationsController';

const throwIfError = (error: unknown) => {
  if (error) throw error;
};

export const supabaseJobOperationsRepository: JobOperationsRepository = {
  async updateShift(id, updates, expectedRoster) {
    if (Object.prototype.hasOwnProperty.call(updates, 'staff_roster')) {
      if (expectedRoster === undefined || Object.keys(updates).length !== 1) {
        throw new Error('Reload the job before saving the roster.');
      }
      const { error } = await supabase.rpc('admin_update_roster', {
        p_shift: id, p_expected: expectedRoster, p_roster: updates.staff_roster,
      });
      throwIfError(error);
      return;
    }
    const { error } = await supabase.from('event_shifts').update(updates).eq('id', id);
    throwIfError(error);
  },
  async deleteShift(id) {
    const { error } = await supabase.from('event_shifts').delete().eq('id', id);
    throwIfError(error);
  },
  async updateTask(id, updates) {
    const { error } = await supabase.from('tasks').update(updates).eq('id', id);
    throwIfError(error);
  },
  async deleteTask(id) {
    const { error } = await supabase.from('tasks').delete().eq('id', id);
    throwIfError(error);
  },
  async createTasks(tasks) {
    const { data, error } = await supabase.from('tasks').insert(tasks).select();
    throwIfError(error);
    return data || [];
  },
  async createCasual(casual) {
    const { data, error } = await supabase.from('casual_staff').insert([casual]).select().single();
    throwIfError(error);
    return data;
  },
  async updateQuote(id, updates) {
    const { error } = await supabase.from('quotes').update(updates).eq('id', id);
    throwIfError(error);
  },
  async deleteQuote(id) {
    const { error } = await supabase.from('quotes').delete().eq('id', id);
    throwIfError(error);
  },
  async updateLead(id, updates) {
    const { error } = await supabase.from('event_leads').update(updates).eq('id', id);
    throwIfError(error);
  },
  async completeLeadsByEmail(email, statuses, updates) {
    const { error } = await supabase.from('event_leads').update(updates).eq('email', email).in('status', statuses);
    throwIfError(error);
  },
};

const postJson = async (url: string, payload: unknown) => {
  const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
  if (!response.ok) throw new Error(`Webhook request failed (${response.status})`);
};

export const browserJobOperationsWebhooks: JobOperationsWebhooks = {
  sendCrew: payload => legacyStaffingDelivery(String(payload.jobId),()=>postJson('https://hook.us2.make.com/52e886sl5b5di7vy8giefqzbw79n1htm', payload)),
  sendCasualBriefing: payload => legacyStaffingDelivery(String(payload.job_id),()=>postJson('https://services.leadconnectorhq.com/hooks/KhUhXR7kCvtBCwTvTrJq/webhook-trigger/z0LI8PfSn3ID8By40npz', payload)),
};

export const useJobOperations = () => useMemo(
  () => createJobOperationsController(supabaseJobOperationsRepository, browserJobOperationsWebhooks),
  [],
);
